import React, {useEffect, useState} from "react";
import CustomGantt from "./components/CustomGantt";
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../../states/StateProvider";
import {ClipLoader} from "react-spinners";
import {data} from "./components/testData";
import "../../gantt.css";
import PortalSelector from "../../components/PortalSelector";
import FPAlreadyExistsModal from "../../components/modal/FPAlreadyExistsModal";

//https://docs.svar.dev/react/gantt/
/**
 * @TODO
 * check:
 * load beraters from API upon clicking on an FP
 * custom sorting by API
 */


const PlanungKalender = () => {
    const [viewMode, setViewMode] = useState("Day");
    const [users, setUsers] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [fps, setFPs] = useState([]);
    const [total, setTotal] = useState(0);
    const [companyFilter, setCompanyFilter] = useState('');

    const [{
        pageBestand,
        sortColumn,
        sortMethod,
        filterID,
        filter,
        dateFilter,
        secretKey,
        portal
    }, dispatch] = useStateValue();

    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const userID = user.ID
    const role = user.role === 'Internal' ? 'i' : user.role === 'ExtRUV' ? 'er' : user.role === 'ExtDGG' ? 'ed' : user.role === 'ManRUV' ? 'mr' : user.role === 'ManDGG' ? 'md' : 'c'
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [ganttReady, setGanttReady] = useState(false);
    const [superAdmin, setSuperAdmin] = useState('')
    const [currentSort, setCurrentSort] = useState({ column: '7', method: 'asc' });

    // Modal state for FP already exists error (lifted from CustomGantt to persist across re-renders)
    const [fpAlreadyExistsModalOpen, setFpAlreadyExistsModalOpen] = useState(false);
    const [duplicateFpId, setDuplicateFpId] = useState(null);
    const [duplicateFpName, setDuplicateFpName] = useState(null);

    useEffect(() => {
        setSuperAdmin(user.isSAdmin)
        if ((user.role === 'ExtDGG' || user.role === 'ManDGG')) {
            dispatch({type: 'SET_PORTAL', item: 'dgg'})
            localStorage.setItem('portal', 'dgg')
        } else if ((user.role === 'ExtRUV' || user.role === 'ManRUV')) {
            dispatch({type: 'SET_PORTAL', item: 'ruv'})
            localStorage.setItem('portal', 'ruv')
        } else {
            if (localStorage.getItem('portal') !== '') {
                dispatch({type: 'SET_PORTAL', item: localStorage.getItem('portal')})
            } else {
                dispatch({type: 'SET_PORTAL', item: 'dgg'})
                localStorage.setItem('portal', 'dgg')
            }
        }
    }, []);

    useEffect(() => {
        const isValid = true;

        if (isValid && portal && userID) {
            const formData = new FormData();
            formData.append('planer', user.email); // Use current user's email as planner
            setLoading(true);
            Api().post('sp_getConsCompanies', formData).then(res => {
                setFPs(res.data);
                setTasks([])
                const tasks = res.data.map((item) => {
                    // Use actual dates from backend or default to current date range
                    const startDate = item.fromDate ? new Date(item.fromDate) : new Date();
                    const endDate = item.toDate ? new Date(item.toDate) : new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)); // Default 30 days

                    // Calculate duration in days
                    const duration = Math.ceil((endDate - startDate) / (24 * 60 * 60 * 1000));

                    return {
                        id: Number(item.FP_ID),
                        text: item.FirmaKurz || item.Firma || `FP-${item.FP_ID}`,
                        start: startDate,
                        end: endDate,
                        duration: duration > 0 ? duration : 1,
                        progress: null,
                        type: "summary", // Summary tasks can have children (consultants)
                        lazy: true, // Enable lazy loading for consultants
                        Links: [],
                        open: false,
                        details: item.details || '', // Use details from database, empty if not present
                        berater_count: item.berater_count || item.BeratersCount || 0 // Map consultant count from API
                    };
                });

            setTasks(tasks);
            setTotal(res.data.length); // Total is the number of companies returned
            setLoading(false);
            setGanttReady(false); // Reset Gantt ready state when new data loads
            }).catch(() => {
                setLoading(false);
                toast.error('Etwas ist schief gelaufen!!');
            });
        }
}, [portal, userID]);

    // Handle company filter changes through manual refetch instead of useEffect
    // to avoid duplicate API calls on initial load

    // Company filter injection disabled - removed to clean up Gantt header
    // Clean up any existing company filter inputs
    useEffect(() => {
        const cleanupTimer = setTimeout(() => {
            const existingFilters = document.querySelectorAll('.company-filter-input');
            existingFilters.forEach(filter => {
                filter.remove();
            });
        }, 1000);

        return () => clearTimeout(cleanupTimer);
    }, [loading, fps.length]);

    const injectCompanyFilterToHeader = () => {
        try {
            // Try multiple selectors to find headers
            const possibleSelectors = [
                '.wx-grid-header .wx-cell',
                '.wx-grid .wx-cell',
                '.wx-header .wx-cell',
                '[class*="header"] [class*="cell"]',
                '.wx-table .wx-cell',
                '.wx-gantt .wx-cell',
                '.wx-grid-header',
                'div[class*="wx-"] div[class*="cell"]'
            ];

            let firmaHeader = null;

            for (const selector of possibleSelectors) {
                const headers = document.querySelectorAll(selector);

                headers.forEach(header => {
                    if (header.textContent && (header.textContent.includes('Firma Kurz') || header.textContent.includes('Firma'))) {
                        firmaHeader = header;
                    }
                });

                if (firmaHeader) break;
            }

            if (firmaHeader && !firmaHeader.querySelector('.company-filter-input')) {

                // Create filter input element directly under the text
                const filterInput = document.createElement('input');
                filterInput.type = 'text';
                filterInput.placeholder = 'Firma filtern...';
                filterInput.value = companyFilter;
                filterInput.className = 'company-filter-input';
                filterInput.style.cssText = `
                    width: calc(100% - 4px);
                    padding: 2px 4px;
                    border: 1px solid #d1d5db;
                    border-radius: 3px;
                    font-size: 10px;
                    outline: none;
                    box-sizing: border-box;
                    margin-top: 2px;
                    display: block;
                `;

                // Add event listener for filter input with debouncing
                let filterTimeout;
                filterInput.addEventListener('input', (e) => {
                    const filterValue = e.target.value;
                    setCompanyFilter(filterValue);

                    // Debounce API calls to avoid too many requests
                    clearTimeout(filterTimeout);
                    filterTimeout = setTimeout(() => {
                        if (portal && userID) {
                            refetchDataWithSort(currentSort.column, currentSort.method);
                        }
                    }, 500); // 500ms debounce
                });

                // Style the input on focus
                filterInput.addEventListener('focus', () => {
                    filterInput.style.borderColor = '#3b82f6';
                    filterInput.style.boxShadow = '0 0 0 1px #3b82f6';
                });

                filterInput.addEventListener('blur', () => {
                    filterInput.style.borderColor = '#d1d5db';
                    filterInput.style.boxShadow = 'none';
                });

                // Insert directly into the header cell
                firmaHeader.appendChild(filterInput);
            } else if (firmaHeader) {
                // Update existing filter input value
                const existingInput = firmaHeader.querySelector('.company-filter-input');
                if (existingInput && existingInput.value !== companyFilter) {
                    existingInput.value = companyFilter;
                }
            }
        } catch (error) {
            // Silent error handling
        }
    };


    const randomDateIn2025 = () => {
        const start = new Date(2025, 0, 1).getTime(); // Jan 1, 2025
        const end = new Date(2025, 11, 31).getTime(); // Dec 31, 2025
        return new Date(start + Math.random() * (end - start));
    };

    const addMonths = (date, months) => {
        const result = new Date(date);
        result.setMonth(result.getMonth() + months);
        return result;
    };

    const links = [];

    const scales = [
        {unit: "month", step: 1, format: "MMMM yyy"},
        {unit: "day", step: 1, format: "d"},
    ];

    const handleTaskClick = (task) => {
        alert(`Clicked on task: ${task.name}`);
    };

    function clearFilters() {
        dispatch({
            type: "SET_SORTBESTANDFILTER",
            item: {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 1, i: null, j: null, k:1}
        })
        dispatch({
            type: "SET_SORTBESTANDFILTERID",
            item: {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: 111, i: null, j: null, k:114}
        })
    }

    // Handle sorting from Gantt component
    const handleSort = (columnId, method) => {

        // Map column IDs to API sort column numbers
        const columnMapping = {
            'text': '8',      // Firma Kurz
            'start': '7',     // Start Datum
            'duration': '9',  // Duration
            'end': '10'       // End Datum
        };

        const sortColumn = columnMapping[columnId] || '7';
        const sortMethod = method === 'desc' ? 'desc' : 'asc';

        setCurrentSort({ column: sortColumn, method: sortMethod });

        // Trigger data reload with new sort
        refetchDataWithSort(sortColumn, sortMethod);
    };

    const refetchDataWithSort = (sortColumn, sortMethod) => {
        console.log('refetchDataWithSort called:', { sortColumn, sortMethod });
        console.trace('Call stack:');
        if (!portal || !userID) return;

        const formData = new FormData();
        formData.append('planer', user.email); // Use current user's email as planner

        setLoading(true);
        Api().post('sp_getConsCompanies', formData).then(res => {
            setFPs(res.data);
            setTasks([])
            const tasks = res.data.map((item) => {
                // Use actual dates from backend or default to current date range
                const startDate = item.fromDate ? new Date(item.fromDate) : new Date();
                const endDate = item.toDate ? new Date(item.toDate) : new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)); // Default 30 days

                // Calculate duration in days
                const duration = Math.ceil((endDate - startDate) / (24 * 60 * 60 * 1000));

                return {
                    id: Number(item.FP_ID),
                    text: item.FirmaKurz || item.Firma || `FP-${item.FP_ID}`,
                    start: startDate,
                    end: endDate,
                    duration: duration > 0 ? duration : 1,
                    progress: null,
                    type: "summary", // Summary tasks can have children (consultants)
                    lazy: true, // Enable lazy loading for consultants
                    Links: [],
                    open: false,
                    details: item.details || '', // Use details from database, empty if not present
                    berater_count: item.berater_count || item.BeratersCount || 0 // Map consultant count from API
                };
            });

            setTasks(tasks);
            setTotal(res.data.length); // Total is the number of companies returned
            setLoading(false);
            setGanttReady(false); // Reset Gantt ready state when new data loads
        }).catch(() => {
            setLoading(false);
            setGanttReady(false);
            toast.error('Etwas ist schief gelaufen!!');
        });
    };


    return (
        <div className="dashboardContainer flex flex-col min-h-96">
            <div className="flex flex-wrap items-center justify-between mb-4">
                <div className="flex items-center gap-x-4 mb-6">
                    <h2 className="text-2xl text-gray-800">Planungs Kalender</h2>
                </div>
            </div>

            <div className="flex-grow" style={{ position: 'relative' }}>
                {loading || !ganttReady ? (
                    <div className="flex justify-center mt-20">
                        <ClipLoader size={50} color={'#b4b4b4'} />
                    </div>
                ) : null}

                {!loading ? (
                    <div style={{
                        visibility: ganttReady ? 'visible' : 'hidden',
                        position: ganttReady ? 'static' : 'absolute',
                        top: 0,
                        left: 0,
                        right: 0
                    }}>
                        <CustomGantt
                            tasks={tasks}
                            links={[]}
                            scales={[
                                { unit: "month", step: 1, format: "MMMM yyy" },
                                { unit: "day", step: 1, format: "d" },
                            ]}
                            onClickTask={handleTaskClick}
                            loading={loading}
                            setLoading={setLoading}
                            portal={portal}
                            user={user}
                            onSort={handleSort}
                            currentSort={currentSort}
                            onGanttReady={() => setGanttReady(true)}
                            setFpAlreadyExistsModalOpen={setFpAlreadyExistsModalOpen}
                            setDuplicateFpId={setDuplicateFpId}
                            setDuplicateFpName={setDuplicateFpName}
                        />
                    </div>
                ) : null}
            </div>

            {/* FP Already Exists Modal */}
            <FPAlreadyExistsModal
                isOpen={fpAlreadyExistsModalOpen}
                onClose={() => setFpAlreadyExistsModalOpen(false)}
                companyName={duplicateFpName}
            />

        </div>
    );
};

export default PlanungKalender;
